import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { SAAMAirSpace } from 'src/app/models/saamAirSpace';
import { PointsService } from 'src/app/services/points.service';
import { SaamFilterTableElem, SaamTrafficService } from 'src/app/services/saamtrafficservice';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-saam-traffic-filter',
  templateUrl: './saam-traffic-filter.component.html',
  styleUrls: ['./saam-traffic-filter.component.scss'],
  standalone: false
})
export class SaamTrafficFilterComponent implements OnInit {

  constructor(
    public menuController : MenuManagementService,
    public saamService: SaamTrafficService,
    public tabsService: TabsService,
    public pointsController: PointsService

  ) { }
  ngOnInit(): void {
  }
  addToMap(){
    let selectedElems: SaamFilterTableElem[] =  this.saamService.saamFilterTableElems.filter((elem) => elem.isselected);
    selectedElems.forEach((elem) => {
      if(!elem.onMap){
        this.pointsController.addSAAMAirSpaceToMap(elem.saamAirspace);
        elem.onMap = true;
      }
    })
  }
  removeSelectedFromMap(){
    let selectedElems: SaamFilterTableElem[] =  this.saamService.saamFilterTableElems.filter((elem) => elem.isselected);
    selectedElems.forEach((elem) => {
      this.pointsController.deleteSaamAirSpaceFromMap(elem.saamAirspace);
      elem.onMap = false;
    })
  }
  selectAll(){
    this.saamService.saamFilterTableElems.forEach((elem) => elem.isselected = true)
  }
  deselectAll(){
    this.saamService.saamFilterTableElems.forEach((elem) => elem.isselected = false)
  }


}

